import React from 'react';

function ManageSubscriptionRow({ title, description, buttonLabel, variant, onClick, disabled }) {
  const baseButtonClasses =
    't-inline-flex t-items-center t-justify-center t-rounded-full t-px-4 t-py-1.5 t-text-sm t-font-semibold disabled:t-opacity-60';

  let variantClasses = 't-bg-secondary t-text-white hover:t-bg-teal-800';

  if (variant === 'secondary') {
    variantClasses = 't-bg-white t-text-secondary t-border t-border-secondary hover:t-bg-teal-50';
  } else if (variant === 'danger') {
    variantClasses = 't-bg-white t-text-red-500 t-border t-border-red-300 hover:t-bg-red-50';
  }

  return (
    <div className="t-flex t-flex-col sm:t-flex-row sm:t-items-center sm:t-justify-between t-gap-3 t-rounded-xl t-border t-border-gray-200 t-bg-white t-px-4 t-py-3">
      <div className="t-flex t-flex-col t-min-w-0">
        <span className="t-text-sm t-font-medium t-text-gray-900 t-break-words">{title}</span>
        <span className="t-text-xs t-text-gray-600 t-break-words">{description}</span>
      </div>
      <button
        type="button"
        className={`${baseButtonClasses} ${variantClasses} t-w-full sm:t-w-auto`}
        onClick={onClick}
        disabled={disabled}
      >
        {buttonLabel}
      </button>
    </div>
  );
}

export default ManageSubscriptionRow;
